import { rankingList } from '@/mocks/home';
import Reveal from '@/components/base/Reveal';

export default function RankingSection() {
  return (
    <section id="ranking" className="border-y border-background-200 bg-background-100/50 py-20 md:py-28">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-8">
        <Reveal>
          <div className="flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <span className="text-xs font-medium tracking-[0.2em] text-primary-600">
                热门榜单
              </span>
              <h2 className="mt-3 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
                今日热度前十，一眼扫完
              </h2>
            </div>
            <p className="text-sm text-foreground-600">
              榜单按讨论热度实时排序，每日 <span className="font-medium text-foreground-900">09:00</span> 更新
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid gap-x-10 gap-y-1 md:grid-flow-col md:grid-cols-2 md:grid-rows-5">
          {rankingList.map((item, index) => (
            <Reveal key={item.rank} delay={index * 50}>
              <a
                href="#featured"
                className="group flex items-center gap-4 border-b border-background-200 py-4 transition-colors hover:bg-background-50"
              >
                <span
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                    item.rank <= 3
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-200 text-foreground-700'
                  }`}
                >
                  {item.rank}
                </span>
                <span className="flex-1 truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-600">
                  {item.title}
                </span>
                <span className="hidden shrink-0 rounded-md bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-900 sm:inline">
                  {item.category}
                </span>
                <span className="flex shrink-0 items-center gap-1 text-xs font-medium text-primary-600">
                  <i className="ri-fire-fill text-sm" />
                  {item.heat}
                </span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}